import { FORM_FIELD_CHANGE, PROCESS_HARDCODED_FORM_DATA } from "./form-entry-action-types";
import { processHardcodedFormData } from "./form-entry-services";

export const changeFieldValue = ({ target }) => {
    const { name, type } = target;
    const value = type === "checkbox" ? target.checked : target.value;
    return {
        type: FORM_FIELD_CHANGE,
        name,
        value
    };
};

export const handleHardCodedFormData = (argsForDerivation, directValues) => ({
    type: PROCESS_HARDCODED_FORM_DATA,
    hardcodedValues: processHardcodedFormData(argsForDerivation, directValues)
});

export default {
    changeFieldValue,
    handleHardCodedFormData
};
